<template>
  <div>
    <div class="cardContainer evaluationHeader" style="padding: 30px">
    <h5 class="medium-title"
      >
        {{ $t("label_evaluation_organization_info") }}
      </h5>
      <b-row>
        <b-col xl="10" offset-xl="1">
          <div v-for="(organization, index) in organizations" :key="index">
              <hr>
              <div style="text-align: center">
                <b-form-group
                      id="organization.selfAssessment_general_business_companyName"
                      horizontal
                      label-class="text-sm-right"
                      label-cols="5"
                      label-for="organization.selfAssessment_general_business_companyName"
                    >
                      <template slot="label">
                        {{$t("label_selfAssessment_general_business_companyName")}}
                      </template>
                      <b-form-input
                        id="organization.selfAssessment_general_business_companyName"
                        :value="organization.selfAssessment_general_business_companyName"
                        :disabled="true"                />
                  </b-form-group>
                  <b-form-group
                    id="organization.selfAssessment_general_business_entityType"
                    horizontal
                    label-class="text-sm-right"
                    label-cols="5"
                    label-for="organization.selfAssessment_general_business_entityType"
                  >
                    <template slot="label">
                      {{$t("label_selfAssessment_general_business_entityType")}}
                    </template>
                    <b-form-input
                      id="organization.selfAssessment_general_business_entityType"
                      :value="$t(organization.selfAssessment_general_business_entityType)"
                      :disabled="true"                />
                </b-form-group>
                <b-form-group
                    id="organization.selfAssessment_general_business_organizationType"
                    horizontal
                    label-class="text-sm-right"
                    label-cols="5"
                    label-for="organization.selfAssessment_general_business_organizationType"
                  >
                    <template slot="label">
                      {{$t("label_selfAssessment_general_business_organizationType")}}
                    </template>
                    <b-form-input
                      id="organization.selfAssessment_general_business_organizationType"
                      :value="$t(organization.selfAssessment_general_business_organizationType)"
                      :disabled="true"                />
                </b-form-group>
                <b-form-group
                    id="organization.selfAssessment_general_business_locationCountry"
                    horizontal
                    label-class="text-sm-right"
                    label-cols="5"
                    label-for="organization.selfAssessment_general_business_locationCountry"
                  >
                    <template slot="label">
                      {{$t("label_selfAssessment_general_business_locationCountry")}}
                    </template>
                    <b-form-input
                      id="organization.selfAssessment_general_business_locationCountry"
                      :value="$t(getCountryFromId(organization.selfAssessment_general_business_locationCountry_id ))"
                      :disabled="true"/>
                </b-form-group>
                <b-form-group
                    id="organization.selfAssessment_general_business_certificationStatus"
                    horizontal
                    label-class="text-sm-right"
                    label-cols="5"
                    label-for="organization.selfAssessment_general_business_certificationStatus"
                  >
                    <template slot="label">
                      {{$t("label_selfAssessment_general_business_certificationStatus")}}
                    </template>
                    <b-form-input
                      id="organization.selfAssessment_general_business_certificationStatus"
                      :value="$t(organization.selfAssessment_general_business_certificationStatus)"
                      :disabled="true"                />
                </b-form-group>
                <b-form-group
                    id="organization.selfAssessment_general_classification_sector"
                    horizontal
                    label-class="text-sm-right"
                    label-cols="5"
                    label-for="organization.selfAssessment_general_classification_sector"
                  >
                    <template slot="label">
                      {{$t("label_selfAssessment_general_classification_sector")}}
                    </template>
                    <b-form-input
                      id="organization.selfAssessment_general_classification_sector"
                      :value="$t(organization.selfAssessment_general_classification_sector)"
                      :disabled="true"                />
                </b-form-group>
                
                <b-form-group
                    id="organization.selfAssessment_general_classification_activityDetailed"
                    horizontal
                    label-class="text-sm-right"
                    label-cols="5"
                    label-for="organization.selfAssessment_general_classification_activityDetailed"
                  >
                    <template slot="label">
                      {{$t("label_selfAssessment_general_classification_activityDetailed")}}
                    </template>
                    <b-form-input
                      id="organization.selfAssessment_general_classification_activityDetailed"
                      :value="$t(organization.selfAssessment_general_classification_activityDetailed)"
                      :disabled="true"                />
                </b-form-group>
                <b-form-group
                    id="organization.selfAssessment_general_size_numberEmployees"
                    horizontal
                    label-class="text-sm-right"
                    label-cols="5"
                    label-for="organization.selfAssessment_general_size_numberEmployees"
                  >
                    <template slot="label">
                      {{$t("label_selfAssessment_general_size_numberEmployees")}}
                    </template>
                    <b-form-input
                      id="organization.selfAssessment_general_size_numberEmployees"
                      :value="$t(organization.selfAssessment_general_size_numberEmployees)"
                      :disabled="true"/>
                </b-form-group>
                <b-form-group
                    id="organization.selfAssessment_general_size_revenue"
                    horizontal
                    label-class="text-sm-right"
                    label-cols="5"
                    label-for="organization.selfAssessment_general_size_revenue"
                  >
                    <template slot="label">
                      {{$t("label_selfAssessment_general_size_revenue")}}
                    </template>
                    <b-form-input
                      id="organization.selfAssessment_general_size_revenue"
                      :value="$t(organization.selfAssessment_general_size_revenue)"
                      :disabled="true"/>
                </b-form-group>
                <b-row class="d-flex justify-content-center">
                  <b-col cols=3>
                    <b-form-group
                    id="organization.selfAssessment_staff_department_total_women"
                    horizontal
                    label-class="text-sm-right"
                    label-cols="4"
                    label-for="organization.selfAssessment_staff_department_total_women"
                  >
                    <template slot="label">
                      {{$t("label_selfAssessment_staff_responsibility_management_column_women")}}
                    </template>
                    <b-form-input
                      id="organization.selfAssessment_staff_department_total_women"
                      :value="$t(organization.selfAssessment_staff_department_total_women)"
                      :disabled="true"/>
                    </b-form-group>
                  </b-col>
                  <b-col cols=3>
                    <b-form-group
                    id="organization.selfAssessment_staff_department_total_men"
                    horizontal
                    label-class="text-sm-right"
                    label-cols="4"
                    label-for="organization.selfAssessment_staff_department_total_men"
                  >
                    <template slot="label">
                      {{$t("label_selfAssessment_staff_responsibility_management_column_men")}}
                    </template>
                    <b-form-input
                      id="organization.selfAssessment_staff_department_total_men"
                      :value="$t(organization.selfAssessment_staff_department_total_men)"
                      :disabled="true"/>
                    </b-form-group>
                  </b-col>
                </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import { createHelpers } from "vuex-map-fields";

export default {
  name: "EvaluationOrganizationInfoTab",
  props: {
    account: {
      type: Object,
      default: () => {},
    },
    evaluationData: {
        type: Object,
        default: () => {}
    },
    organizations: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
        business: [],
        selfAssessments: [],
    };
  },
  created: async function(){
    await this.$store.dispatch("COUNTRIES_GET")
  },
  computed: {
    ...mapGetters({
        countries: "getCountries",
        currentSnapshot: "getCurrentSnapshot",
    }),
  },
  watch: {
        
    },
  methods: {
    getCountryFromId(id){
        var temp
        this.countries.forEach(item => {
            if(item.id === id)
                temp = item.country
        })
        return temp
    },
    
  }
};
</script>

<style scoped lang="scss" scoped>

@import "../../../../assets/css/variables";

.medium-title{
  text-align: center;
  font-size: 20px;
  font-family: $font-subtitle;
  text-transform: uppercase;
  margin-bottom: 10px;
  }
</style>
